import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-Q4-logo_svg__Layer_1",
  version: "1.1",
  viewBox: "0 0 49.4 49.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-Q4-logo_svg__st0{fill:#007680}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-Q4-logo_svg__Vector_15",
      d: "m4.6 38.2 1.1-.2c3.4-.7 6.6-1.6 9.8-2.9C21.1 33 26 29.6 30 25.2c2.9-3.3 5.9-6.6 8.9-9.8 1.7-2 3.4-4 5.1-5.9h.1C40.2 4.3 34.5 1.1 28.2.2c-6.3-.9-12.7.7-17.9 4.5C5.1 8.4 1.6 14 .4 20.3-.8 26.6.5 33 4 38.4h.6Z",
      class: "svg-Q4-logo_svg__st0"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-Q4-logo_svg__Vector_16",
      d: "m47.1 14-6.2 10.6-8.1 13.9c-.2.2-.4.4-.7.5-1.3.6-2.8 1.2-4.1 1.8l-9.6 4-4.8 2c4.6 2.3 9.8 3.1 14.9 2.3 5.1-.8 9.8-3.2 13.5-6.8 3.7-3.6 6.2-8.3 7.1-13.3.9-5.1.2-10.3-2-15Z",
      class: "svg-Q4-logo_svg__st0"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "Q4-logo"}) } }